import { render, staticRenderFns } from "./ImagesUploader.vue?vue&type=template&id=35af44ca&scoped=true&"
import script from "./ImagesUploader.vue?vue&type=script&lang=js&"
export * from "./ImagesUploader.vue?vue&type=script&lang=js&"
import style0 from "./ImagesUploader.vue?vue&type=style&index=0&id=35af44ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35af44ca",
  null
  
)

export default component.exports